var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"alt":"Vue logo","width":"200","height":"200","src":require("@/assets/logo_cbp.png")}}),_c('HomePage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }